import { BILLION, MILLION, THOUSAND } from '@swf/poker';

import type { Game } from '../types/Game';

export const moneyParser = (str: string) => parseFloat(str.replace(/[^0-9.]/g, ''));

export const scalePrizeValue = (amount: string) => {
  const num = moneyParser(amount);
  if (/K/i.test(amount)) return num * THOUSAND;
  if (/M|MILLION/i.test(amount)) return num * MILLION;
  if (/B|BILLION/i.test(amount)) return num * BILLION;
  return num;
};

export const getGameParams = (a: Game, b: Game) => {
  const buyInGameA = scalePrizeValue(a.buyIn);
  const buyInGameB = scalePrizeValue(b.buyIn);
  const winUpToGameA = scalePrizeValue(a.winUpTo);
  const winUpToGameB = scalePrizeValue(b.winUpTo);

  return {
    buyInGameA,
    buyInGameB,
    winUpToGameA,
    winUpToGameB
  };
};
/*
  https://jira.pyrsoftware.ca/jira/browse/POKER-7246

  RM games sort mechanism:
  1. free games first
  2. promo games second
  3. rest of the games third

  PM games sort mechanism:
  1. free games first
  2. promo games last
  3. rest of the games go in between

  Then all the game types are further sorted by:
  1. buyIn
  2. winUpTo where buyIns are equal
 */
export const sortRMGames = (a: Game, b: Game) => {
  const { buyInGameA, buyInGameB, winUpToGameA, winUpToGameB } = getGameParams(a, b);

  // Check buyIn of 0
  if (buyInGameA === 0 && buyInGameB !== 0) return -1;
  if (buyInGameB === 0 && buyInGameA !== 0) return 1;

  // Sort by buyIn
  if (buyInGameA !== buyInGameB) return buyInGameA - buyInGameB;

  // Sort by winUpTo if buyIn is the same
  if (isNaN(winUpToGameA) && !isNaN(winUpToGameB)) return 1;
  if (!isNaN(winUpToGameA) && isNaN(winUpToGameB)) return -1;

  if (!isNaN(winUpToGameA) && !isNaN(winUpToGameB)) return winUpToGameA - winUpToGameB;

  // For non-monetary winUpTo, sort by game name
  return a.game.localeCompare(b.game);
};

export const sortPMGames = (a: Game, b: Game) => {
  const { buyInGameA, buyInGameB, winUpToGameA, winUpToGameB } = getGameParams(a, b);
  // Games with buyIn of 0 come first
  if (buyInGameA === 0 && buyInGameB !== 0) return -1;
  if (buyInGameB === 0 && buyInGameA !== 0) return 1;

  // Sort by buyIn for the rest
  if (buyInGameA !== buyInGameB) return buyInGameA - buyInGameB;

  // If buyIn is the same or for games with promoRef, sort by winUpTo
  return winUpToGameA - winUpToGameB;
};
